import { render, staticRenderFns } from "./HealthCodeRecordHandle.vue?vue&type=template&id=6b97a4f2"
import script from "./HealthCodeRecordHandle.vue?vue&type=script&lang=js"
export * from "./HealthCodeRecordHandle.vue?vue&type=script&lang=js"
import style0 from "./HealthCodeRecordHandle.vue?vue&type=style&index=0&id=6b97a4f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports